import SocialMonitorEdit from './socialMonitorEdit'
export default SocialMonitorEdit
